export default __webpack_public_path__ + "static/media/chem.e5fdef5f.svg";